<template>
  <div class="index" id="home" :style="{paddingTop: $store.state.headerHeight + 'px'}" v-loading="pageLoading">
    <SubHeader :showUser="true" :showNav="true"></SubHeader>
    
    <div class="index-vip" v-if="plat!=120 && !vipInfo.is_buy" v-show="false" @click="toVIP">
      <!-- 不是会员1 -->
      <div class="btn">
          开通会员
        </div>
    </div>
    <div class="index-vip2" v-else-if="plat != 120" v-show="false"  @click="toVIP">
      <!-- 是会员 -->
      <div class="content">
        <b>尊敬的会员用户</b>
        您的会员有效期到{{vipInfo.end_time}}
      </div>
  
        <div class="btn">
          立即续费
        </div>
    </div>
    <van-swipe class="my-swipe2" :autoplay="3000" indicator-color="black" :show-indicators="true">
      <van-swipe-item v-if="swiperData.length==0">
        <div class="placeBanner">
          <img :src="$logoBig"/>
        </div>
      </van-swipe-item>
      <van-swipe-item v-for="item in swiperData" :key="item.id">
        <img :src="item.cover" @click="goDetail(item.url)"/>
      </van-swipe-item>
    </van-swipe>
    <div class="quality" v-if="zhuangjiaList.length">
      <div class="part-titleYingyou" v-if="!pageLoading">
        <!-- <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E6%8E%A8%E8%8D%90%402x.png"/> -->
        <div class="part-title_text">育儿专家课堂</div>
        <p @click="toList(217)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
      </div>
      <div class="list12">
        <div v-for="(item, index) of zhuangjiaList.slice(0,6)" :key="index" >
          <PriceCardjn :desShow="false" :study-tim-show="true" :index="index" :cardData="item"  @click.native="goDetail(item.id)" type="demonstrate"></PriceCardjn>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="level" v-if="lessonYuer[yyList2Index]">
      <div class="part-titleYingyou part-title2" v-if="!pageLoading">
        <div class="part-title_text">育儿百科系列</div>
        <p @click="toList(218)">查看更多 <van-icon name="arrow" size="12" color="#000"/></p>
      </div>
      <div class="tabList">
          <p :class="{active:yyList2Index == index}" :key="index" v-for="(item, index) in lessonYuer" @click="yyList2Index = index">{{ item.name }}</p>
      </div>
        <PriceCard v-for="(v, i) of lessonYuer[yyList2Index].list.flat().slice(0,4)"  :key="i"   @click.native="goDetail(v.id)" :index="v.id" :cardData="v"></PriceCard>
    </div>
    <!-- 职业认证 -->
     <div class="quality" v-if="jnLesson.list">
      <div class="part-titleYingyou part-title2" v-if="!pageLoading">
        <div class="part-title_text">{{jnLesson.name}}</div>
        <p @click="toList(jnLesson.id)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
      </div>
        <div v-for="(item, index) of jnLesson.list.flat().slice(0,4)" :key="index" >
          <PriceCard :index="index" :cardData="item"  @click.native="goDetail(item.id)" type="demonstrate"></PriceCard>
        </div>
      <div class="line"></div>
    </div>
   
    <div class="live" style="padding-bottom:20px" v-if="liveData.length">
      <div class="part-titleYingyou" v-if="!pageLoading">
        <div class="part-title_text">直播专栏</div>
        <!-- <p @click="goList('live')">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p> -->
      </div>
      <div class="hot-list">
        <LiveCard v-for="(item, index) of liveData" :key="index" :index="index" :cardData= "item"  @click.native="goLiveDetail(item)"></LiveCard>
      </div>
    </div>
    
    <div class="bottom">—   到底了…  —</div>
    <!-- <sub-footer :top="top" @toTop="toTop"></sub-footer> -->
    <!-- <img 
      class="topImg" v-if="top<0" @click="toTop"
      src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%9B%9E%E5%88%B0%E9%A1%B6%E9%83%A8%402x.png"/> -->
  </div>
  </template>
  
  <script>
  import PriceCard from "@/components/PriceCard03";
  import PriceCardjn from "@/components/PriceCardJn03";
  import VideoCard from "@/components/VideoCard";
  import TopCard from "@/components/TopCard";
  import SubHeader from "@/components/SubHeaderJiazhang03";
  import SubFooter from "@/components/YingyouTab";
  import LiveCard from "@/components/LiveCard";
  import ideaList from "@/components/ideaList";
  import { resolve } from "path";
  import { Toast } from "vant";
  import { timingSafeEqual } from "crypto";
  
  // import Vue from 'vue'
  // import VConsole from 'vconsole';
  // Vue.prototype.Vconsole = new VConsole()
  
  export default {
    components: {
      PriceCard,
      PriceCardjn,
      VideoCard,
      TopCard,
      SubHeader,
      SubFooter,
      LiveCard,
      ideaList
    },
    computed: {
      titleName() {
        return this.$store.state.plat.name;
      },
      plat() {
        return this.$store.state.plat_id;
      },
      indexTab() {
        return this.$store.state.indexTab2;
      },
    },
    data() {
      return {
        tabActive: "index",
        active: 0,
        pageLoading: true,
        listLoading: false,
        yyList2Index:0,
        swiperData: [],
        category: [],
        gpLesson: [],
        lessonYuer:[],
        jnLesson: [],
        liveData: [],
        vipInfo:{},
        zhuangjiaList:[],
        demonstrate:[],
        top:0,
      };
    },
    async mounted() {
      this.init();
      this.handleScrollToc()
      window.addEventListener("scroll", this.handleScrollToc, true);
    },
    beforeDestroy(){
      window.removeEventListener("scroll", this.handleScrollToc, true);
    },
    methods: {
      toTop(){
        let timer = setInterval(()=>{
          document.documentElement.scrollTop = document.documentElement.scrollTop>=20 ? document.documentElement.scrollTop-20 : 0
          if(document.documentElement.scrollTop<=0){
            clearInterval(timer)
          }
        },10)
        
      },
      handleScrollToc() {
        let info = document.getElementById("home").getBoundingClientRect();
        this.top = info.top;
      }, 
      async init() {
        // this.$toast.loading({
        //   message: '加载中...',
        //   forbidClick: true,
        // });
        let res = await this.$request.jiazhangIndex03( {
          plat_id: this.plat,
          terminal: 1, //1 pc 2 小程序
          },);
        // this.$toast.clear();
        this.pageLoading = false
        if (res.code == 0) {
          this.liveData = res.data.live_stream.map(item=>{
            let list  = item.data.map(v=>{v.category_name=item.category_name; return v})
            return list
            }).flat(1)

            // this.lessonYuer = res.data.category.find(item=>item.id == 218).goods
            // this.jnLesson = res.data.category.find(item=>item.id == 219).goods[0]
            // this.zhuangjiaList =  res.data.category.find((item) => item.id == 217).goods.filter(v=>  v.goods[0].length).map(vv=>vv.goods[0]).flat();

            this.lessonYuer = res.data.category_list.find(item=>item.id == 218).list
          this.jnLesson = res.data.category_list.find(item=>item.id == 219).list[0]
          this.zhuangjiaList =  res.data.category_list.find((item) => item.id == 217).list.filter(v=>  v.list[0].length).map(vv=>vv.list[0]).flat();

          this.swiperData = res.data.banner || []
  
          this.$store.commit('SET_VIP',res.data.plat_vip)
        } else {
          this.$toast(res.msg);
        }
      },
      goDetail(id) {
        if(id){
          let url = `./detailYingyou?id=${id}`
          this.$router.push(url); 
        } 
      },
      goLiveDetail(item) {
        let {
          name,
          video_url,
          host,
          img_url,
          category_name,
          video_id,
          ccid,
          cover,
          id
        } = item;
        let videoId = video_id;
        let type = 'aliyun'
        if (ccid) {
          id = ccid;
          type = 'cc';
        }
        if (video_url) {
          this.$router.push(`./LiveDetail?id=${id}&name=${name}&url=${video_url}&host=${host}&cover=${img_url}&category_name=${category_name}`);
        } else if(videoId){
          this.$router.push(`./LiveDetail?id=${id}&name=${name}&videoId=${videoId}&host=${host}&type=${type}&cover=${cover}&category_name=${category_name}`);
  
        } else {
          this.$toast('没有视频')
        }
  
      },
      toList(id){
        this.$router.push(`./lessonYingyou?id=${id}`);
      },
      toVIPList(id){
        this.$router.push(`./vipLesson?id2=${id}`);
      },
      goList(type) {
        this.$router.push(`./${type}`);
      },
    
      toVIP(){
        // if(!localStorage.getItem('token')){
        //   this.$dialog.confirm({
        //     title: '提示',
        //     message: '请登录后查看',
        //     confirmButtonText:'立即登录',
        //   })
        //     .then(() => {
        //       // on confirm
        //       this.$router.push('./login/phone')
        //     })
        //     .catch(() => {
        //       // on cancel
        //     });
        //     return 
        // }
        this.$router.push({
          path:'./vip/detailVIP',
          query:{
            id:this.vipInfo.goods_id
          }
        })
        
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
    .topImg{
      position: fixed;
      z-index: 110;
      right: 50px;
      bottom: 50px;
      width: 80px;
      height: 80px;
    }
    .my-swipe2{
      width: 690px;
      margin: 30px auto 0;
      img{
        width: 100%;
        border-radius: 10px;
      }
      .placeBanner{
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ebebeb;
        img{
          width: auto;
        }
      }
    }
    .index-vip {
      width: 690px;
      height: 172px;
      margin: 23px auto 18px;
      display: block;
      background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/vip.png') no-repeat;
      background-size: 100%;
      position: relative;
    }
   
    .index-vip2 {
      width: 690px;
      height: 172px;
      margin: 23px auto 18px;
      display: block;
      background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/isVipBg.png') no-repeat;
      background-size: 100%;
      position: relative;
    }
    .index-vip2 .content{
    position: absolute;
    left:30px;
    top:40px;
    color: #6a4a2c;
    font-size: 24px;
  }
  .index-vip2 .content b{
    display: block;
    font-weight: bold;
    font-size: 34px;
    margin-bottom: 15px;
  }
  .index-vip
   .btn, .index-vip2 .btn {
    position: absolute;
    bottom: 37px;
    right: 37px;
    width: 155px;
    height: 56px;
    background: #6a4a2c;
    border-radius: 28px;
    text-align: center;
    line-height: 56px;
    color: #fff;
    font-size: 26px;
  }
  .index {
    min-height: 100vh;
    overflow: hidden;
    // padding-bottom: 2rem;
    background: #f9f9f9;
    padding-top: 100px;
    box-sizing: border-box;
  }
  .part-titleYingyou{
    display: flex;
    align-items: center;
    padding: 60px 30px 30px;
    >img{
      width: 36px;
      margin-right: 10px;
    }
    .part-title_text{
      flex: 1;
      font-weight: 500;
      color: #000000;
      font-size: 36px;
    }
    p{
      color: #999;
      font-size: 24px;
    }
  }
  .level{
    >b{
      font-size: 30px;
      padding: 0 0.4rem 0.2rem;
      display: block;
    }
  }
  .tabList{
    padding-top: 10px;
    padding-left: 30px;
    margin-bottom: 36px;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    overflow-x: scroll;
    &::-webkit-scrollbar{
      height: 0 !important;
    }
   -ms-overflow-style: none;
   overflow: -moz-scrollbars-none;
    p{
      display: inline-block;
      padding: 0 16px;
      border-radius: 24px;
      height: 48px;
      line-height: 48px;
      background: #fff;
      margin-right: 20px;
      font-size: 24px;
      color: #666;
      font-weight: 400;
    }
    p.active{
      background-color: #F08E00;
      color: #fff;
    }
    
  }
  .sroll{
    padding-left: 30px;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    overflow-x: scroll;
    &::-webkit-scrollbar{
      height: 0 !important;
    }
   -ms-overflow-style: none;
   overflow: -moz-scrollbars-none;
   .srollItem{
    display: inline-block;
    width: 70vw;
    margin-right: 20px;
   }
  }
  .quality {
    width: 100vw;
  
    .quality-list {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      .list13{
        flex: 1;
        margin-left: 20px;
        overflow: hidden;
        &:last-of-type{
          margin-right: 20px;
        }
      }
    }
    .list12{
      width: 100vw;
      padding: 0 30px;    
      >div{
        width: calc((100vw - 80px)*0.5);
        display: inline-block;
        &:nth-of-type(2n+1){
          margin-right: 20px;
        }
      }
    }
  }
  .bottom{
    font-size: 24px;
    font-weight: 400;
    color: #CCCCCC;
    line-height: 34px;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  h3{
    padding: 40px 30px 20px;
    font-size: 36px;
    color: #333;
    font-weight: 600;
    margin: 0;
  }
  .part-title_text2{
    font-size: 32px !important;
  }
  .part-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
  }
  .part-title2 {
    padding-top:25px
  }
  
  </style>
  